// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#save-recovery-codes {
    margin-left: 0.5em;
    margin-bottom: 1em;
}

#recovery-codes-grid {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: auto auto auto auto auto;
    text-align: center;
    margin: 1em 0;
}

.recovery-code {
    font-family: monospace;
    font-size: large;
}

.recovery-codes-page .copy-button {
    margin: 0 auto;
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/RecoveryCodes.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB","sourcesContent":["#save-recovery-codes {\n    margin-left: 0.5em;\n    margin-bottom: 1em;\n}\n\n#recovery-codes-grid {\n    display: grid;\n    grid-auto-flow: column;\n    grid-template-rows: auto auto auto auto auto;\n    text-align: center;\n    margin: 1em 0;\n}\n\n.recovery-code {\n    font-family: monospace;\n    font-size: large;\n}\n\n.recovery-codes-page .copy-button {\n    margin: 0 auto;\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
